//공통 response 에러 메세지
export const _ResponseMSG = {
  BAD_PARAMETER: '요청 파라미터가 잘못되었습니다.',
  NOT_FOUND: '리소스를 찾지 못했습니다.',
  UNAUTHORIZED: '권한이 없습니다.',
  UNAUTHENTICATED: '인증되지 않았습니다.',
  INVALID_ACCESS: '유효하지 않은 접근입니다.',
  INVALID_STATE: '적용가능하지 않은 상태입니다.',
  UNAVAILABLE: '이용가능하지 않습니다.',
  VIOLATION: '사용 규칙에 맞지 않습니다.',
  DUPLICATE: '중복되었습니다.',
  BUSY: '서비스가 지연되고 있습니다.',
  NOT_SUPPORTED: '지원되지 않는 기능입니다.',
  PAYMENT_ERROR: '결제 에러입니다.',
  MISMATCH: '정보가 일치하지 않습니다.',
  SERVER_ERROR: '서버 에러입니다.'
}

export const rescode = {
  REQ_SUCCESS:"OK",//요청이 성공하였습니다.
  BAD_PARAMETER:"BAD_PARAMETER",//요청 파라미터가 잘못되었습니다.
  NOT_FOUND:"NOT_FOUND",//리소스를 찾지 못했습니다.
  UNAUTHORIZED:"UNAUTHORIZED",//권한이 없습니다.
  UNAUTHENTICATED:"UNAUTHENTICATED",//인증되지 않았습니다.
  UNAPPROVED:"UNAPPROVED",//승인되지 않았습니다.
  DUPLICATE:"DUPLICATE",//중복되었습니다.
  INVALID_ACCESS:"INVALID_ACCESS",//유효하지 않은 접근입니다.
  BUSY:"BUSY",//서비스가 지연되고 있습니다.
  SERVER_ERROR:"SERVER_ERROR",//서버 에러입니다.
  EXTERNAL_SERVER_ERROR:"EXTERNAL_SERVER_ERROR",//외부 서버 에러입니다.
}

//예약상태
export const _bookingStatus = {
  BookingRequested: '예약신청',
  BookingRejected: '예약불가',
  Booked: '예약완료',
  CancelRequested: '취소신청',
  Cancelled: '취소완료',
  Visited: '방문완료',
  NoShow: '노쇼'
}
//예약아이템상태
export const _orderItemStatus = {
  Available: '',
  Invalidated: '',
  RefundRequested: '',
  RefundFailed: '',
  Refunded: '',
  BookingConnected: '',
  Consumed: ''
}

//상품타입
export const _goodsType = {
  MobileCoupon: '모바일쿠폰',
  BookingCoupon: '예약권',
  Booking: '예약',
  MoneyCoupon: '금액권',
  CacheCoupon: '캐시권'
}

//결제방식
export const _agentPaymentMethod = {
  InicisCard: '신용카드',
  InicisVBank: '가상계좌',
  UserCash: '캐시',
  UserPoint: '포인트',
  HappyCash: '해피머니',
  BenepiaPoint: '베네피아포인트',
  SpecialOffer: '특별주문'
}

export const _orderStatus = {
  Purchased: '결제완료',
  CancelRequested: '취소신청',
  CancelFailed: '취소실패',
  Cancelled: '취소완료'
}
export const _storeType = {
  Buffet: '뷔페',
  Western: '서양식',
  Korean: '한식',
  Chinese: '중식',
  Japanese: '일식',
  Italian: '이탈리안',
  French: '프렌치',
  Asian: '아시안',
  Mexican: '멕시칸',
  Fusion: '퓨전',
  Dessert: '디저트',
  Barbecue: '캠핑&바비큐',
  Bakery: '카페&베이커리',
  Pub: '펍&바',
  HomeParty: '홈파티',
  Takeout: '테이크아웃',
  Spa: '스파',
  Etc: '기타'
}
